/* eslint-disable */
import IconButton from '@material-ui/core/IconButton';
import MuiLink from '@material-ui/core/Link';
import Snackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import cn from 'classnames';
import get from 'lodash/get';
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import BannersContext from '../../Contexts/Banners/Banners.context';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import withServices from '../../Contexts/Services/WithServices.context';
import { createPlaceOrderPageLink } from '../../Pages/PlaceOrder/PlaceOrder.page.route';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import ordersActionCreators from '../../State/Store/Orders/Orders.actions';
import sidebarOpenSelector from '../../State/Store/Sidebar/Selectors/SidebarOpen.selector';
import sidebarActionCreators from '../../State/Store/Sidebar/Sidebar.actions';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_FAB_PLACE_ORDER_CLICK } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import EditProfileDialogComponent from '../EditProfileDialog/EditProfileDialog.component';
import Navbar from '../Navbar/Navbar.component';
import Sidebar from '../Sidebar/Sidebar.component';
import SpeedDialWrapperComponent from '../SpeedDialWrapper/SpeedDialWrapper.component';
import basePageStyles from './BasePage.component.styles';
import './Page.component.i18n';
import PagePropTypes from './Page.component.props';

/**
 * PageComponent
 * @export
 * @class PageComponent
 * @extends {React.Component<PageComponentComposedProps, PageComponentState>}
 */
export class PageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<PageComponentProps>}
   * @memberof PageComponent
   */
  static defaultProps = {
    hideNavbar: false,
    hideSidebar: false,
    padding: `normal`,
  };

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`Page`}
   * @memberof PageComponent
   */
  static displayName = `Page`;

  static contextType = BannersContext;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof PageComponent
   */
  static propTypes = PagePropTypes;

  /**
   * Data specific to the `<PageComponent />` instance
   * @type {PageComponentState}
   * @memberof PageComponent
   */
  state = {
    prefix: ``,
    snack: { autoHideDuration: 6000, message: ``, show: false, type: `` },
    title: ``,
  };

  /**
   * A method to be called when unmounting to remove the listener to the `I18nService`
   * @type {VoidFunction}
   * @memberof PageComponent
   */
  unsubscribePrefix;

  /**
   * A method to be called when unmounting to remove the listener to the `I18nService`
   * @type {VoidFunction}
   * @memberof PageComponent
   */
  unsubscribeTitle;

  /**
   * The constructor
   * @static
   * @type {Object}
   * @memberof BasePageComponent
   * @param {Object} props The props object
   */
  constructor(props) {
    super(props);
  }

  /**
   * Checks if any notifications are unread
   * @returns {void} void
   * @memberof PageComponent
   */
  async checkForUnreadNotifications() {
    const { services } = this.props;
    const ajaxResponse = await services.notificationService.hasNotifications();
    this.setState({
      checkingNotifications: false,
      hasUnreadNotifications: get(ajaxResponse, `response.responseData.hasUnread`, false),
    });
    return;
  }

  /**
   * When the component mounts, fetch the translations for the `<title />`
   * @returns {void} void
   * @memberof PageComponent
   */
  async componentDidMount() {
    const { services } = this.props;
    this.performTranslation();
    if (services.authService.isAuthenticated()) {
      this.setState({
        checkingNotifications: true,
      });
      // on every new page we need to check for new notifications
      await this.checkForUnreadNotifications();
    }
    return;
  }

  resetNotifications = () => {
    this.setState({
      hasUnreadNotifications: false,
    });
  };

  /**
   * Remove the listener to the `I18nService`
   * @returns {void} void
   * @memberof PageComponent
   */
  componentWillUnmount() {
    this.unsubscribePrefix();
    this.unsubscribeTitle();
    clearAllBodyScrollLocks();
  }

  /**
   * Handle when a translation is observed
   * @param {string} name The `name` of the translation to observe
   * @returns {I18nServiceLocaleChangedHandler} The handler for the translation
   * @memberof PageComponent
   */
  handleOnTranslation = (name) => (error, payload) => {
    const { key, lang, translation } = payload;
    if (error) {
      throw error;
    }
    this.setState({
      [name]: translation || `Failed to load: ${lang}.${key}`,
    });
  };

  /**
   * Tranlate the `<title />` and its prefix
   * @returns {void} void
   * @memberof PageComponent
   */
  performTranslation = () => {
    const { entry, services, title, titleData } = this.props;
    this.unsubscribePrefix = services.i18nService.observeTranslation(`Page.Prefix`, { company: entry.company }, this.handleOnTranslation(`prefix`));
    this.unsubscribeTitle = services.i18nService.observeTranslation(title, titleData, this.handleOnTranslation(`title`));
  };

  /**
   * Render the `<Navbar />` conditionally
   * @returns {React.Component} The `<Navbar />`
   * @memberof PageComponent
   */
  renderNavbar = () => {
    const {
      defaultLanguageHeading,
      englishTitle,
      heading,
      hideLogo,
      hideMenuIcon,
      hideNavbar,
      largeNavBar = false,
      hideSidebar,
      hideUserMenu,
      renderExtensions,
    } = this.props;
    const { checkingNotifications, hasUnreadNotifications } = this.state;
    const { details } = this.context;

    if (hideNavbar) {
      return null;
    }
    const pageTitle = heading ? { heading } : { englishTitle };
    return (
      <Navbar
        checkingNotifications={checkingNotifications}
        defaultLanguageHeading={defaultLanguageHeading}
        hasUnreadNotifications={hasUnreadNotifications || (details && details.visible)}
        heading={heading}
        hideLogo={hideLogo}
        hideMenuIcon={hideMenuIcon || hideSidebar}
        hideUserMenu={hideUserMenu}
        large={largeNavBar}
        renderExtensions={renderExtensions}
        resetNotifications={this.resetNotifications}
        {...pageTitle}
      />
    );
  };

  /**
   * Render the `<Sidebar />` conditionally
   * @returns {React.Component} The `<Sidebar />`
   * @memberof PageComponent
   */
  renderSidebar = () => {
    const { classes, hideSidebar, sidebarContent } = this.props;
    if (hideSidebar) {
      return null;
    }
    // Note: This wrapping `div` is required
    return (
      <div className={classes.sidebarMain}>
        <Sidebar anchor="left" permSizing={{ mdDown: true }} tempSizing={{ lgUp: true }}>
          {sidebarContent}
        </Sidebar>
      </div>
    );
  };

  /**
   * Returns true if usr logged in missing details
   * @returns {boolean} true if details are missing
   * @memberof PageComponent
   */
  isMissingDetails() {
    const {
      services: { authService },
    } = this.props;
    if (authService.isAuthenticated()) {
      const {
        userInfo: { email, firstName, lastName },
      } = this.props;
      return !firstName || !lastName || !email;
    }
    return false;
  }

  /**
   * Render the edit dialog
   * @returns {React.Component} The rendered `<React.Fragment />`
   * @memberof PageComponent
   */
  renderEditDialog() {
    const { userInfo } = this.props;
    const { snack } = this.state;
    return (
      <React.Fragment>
        <Snackbar
          action={[
            <IconButton aria-label="Close" color="inherit" key="close" onClick={() => this.setState({ snack: { ...snack, show: false } })}>
              <CloseIcon />
            </IconButton>,
          ]}
          autoHideDuration={snack.autoHideDuration}
          message={snack.message}
          onClose={this.onHandleCloseMessage}
          open={snack.show}
        />
        <EditProfileDialogComponent
          editProfileMessage={(snackMsg) => {
            return this.setState({
              snack: { autoHideDuration: snackMsg.autoHideDuration, message: snackMsg.message, show: snackMsg.show, type: snackMsg.type },
            });
          }}
          firstLogin
          open
          userInfo={userInfo}
        />
      </React.Fragment>
    );
  }

  /**
   * Render the component
   * @returns {React.Component} The rendered `<PageComponent />`
   * @memberof PageComponent
   */
  render() {
    const { children, classes, description, englishTitle, sideBarOpen, alwaysCenter, history, width, actions } = this.props;
    const { prefix, title } = this.state;
    // when user is missing required details, ask him to update it before doing anything else
    if (this.isMissingDetails()) {
      return this.renderEditDialog();
    }

    return (
      <div className={cn(alwaysCenter ? classes.alwaysCenter : classes.root, !sideBarOpen && classes.rootWithoutPadding)}>
        <Helmet titleTemplate={`${prefix} - %s`}>
          <title>{englishTitle || title}</title>
          {description && <meta content={description} name="description" />}
        </Helmet>
        {this.renderNavbar()}
        {/* {this.renderNotificationBanner()} */}
        {this.renderSidebar()}
        {children}
        {isWidthDown(`xs`, width) && (
          <SpeedDialWrapperComponent
            name="PlaceOrderSpeedDial"
            icon={<AddIcon />}
            options={[
              {
                icon: (
                  <MuiLink color="inherit">
                    <AddIcon className={classes.icon} />
                  </MuiLink>
                ),
                onClick: () => {
                  actions.uiTriggered({
                    payload: {
                      data: {
                        name: `fabPlaceOrderClick`,
                      },
                    },
                    type: UI_FAB_PLACE_ORDER_CLICK,
                  });
                  history.push(createPlaceOrderPageLink());
                },
                tooltip: {
                  i18n: {
                    data: {},
                    key: `Place An Order`,
                    englishValue: `Place An Order`,
                  },
                },
              },
            ]}
          />
        )}
      </div>
    );
  }
}

/** @type {React.ComponentClass<PageComponentProps>} */
const Page = compose(
  withEntries,
  withServices,
  withRouter,
  withWidth(),
  withStyles(themeCreateInjectableStyles(basePageStyles), { withTheme: true }),
  connect(
    (state) => {
      const sideBarOpen = sidebarOpenSelector(`left`);
      return {
        sideBarOpen: sideBarOpen(state),
        userInfo: userProfileSelector(state),
        filters: state.filters,
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...sidebarActionCreators,
          ...filtersActionCreators,
          ...ordersActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(PageComponent);

export default Page;
